import { render, staticRenderFns } from "./CompanyStyles.vue?vue&type=template&id=77d17647&"
import script from "./CompanyStyles.vue?vue&type=script&lang=ts&"
export * from "./CompanyStyles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports